export default __webpack_public_path__ + "static/media/blog-video.dec1e6ea.webp";